import { useEffect, useMemo } from 'react'

import { trace } from '@krp/client-runtime'
import { platformMyResources } from '@krp/platform-ui'
import { TRACE_DEEP_POLL_MS, aqsiTraceDeep } from '@krp/resource-aqsi-ui'

import { useAppSelector } from '../../app/hooks'
import { AQSI_MINE } from './aqsiMine'

/**
 * Трассировка продаж источника (RP-SALE-TRACE) для экрана продажи. Права решает сервер: источник есть в «моих ресурсах» с правом
 * `sales.trace` — точки продаж собираются и уходят; нет — трассировка этого источника в браузере выключена вовсе (ни сбора, ни
 * запросов). Флаг подробного режима читается раз в минуту, пока экран открыт, и только при праве.
 */
export function useTraceSession(resourceId: string): void {
  platformMyResources.useQuerySubscription(AQSI_MINE.trace, { skip: resourceId === '' })
  const select = useMemo(() => platformMyResources.select(AQSI_MINE.trace), [])
  const mine = useAppSelector(select)
  const allowed = resourceId !== '' && (mine.data ?? []).some((resource) => resource.id.toLowerCase() === resourceId.toLowerCase())

  const args = useMemo(() => ({ resourceId }), [resourceId])
  aqsiTraceDeep.useQuerySubscription(args, { skip: !allowed, pollingInterval: TRACE_DEEP_POLL_MS })
  const selectDeep = useMemo(() => aqsiTraceDeep.select(args), [args])
  const deep = useAppSelector(selectDeep)
  const deepEnabled = allowed && deep.data?.enabled === true

  useEffect(() => {
    trace.allow(resourceId, allowed)
    return () => trace.allow(resourceId, false)
  }, [allowed, resourceId])
  useEffect(() => {
    trace.setDeep(deepEnabled)
    return () => trace.setDeep(false)
  }, [deepEnabled])
}
